import {
  CONNECT_FAILURE,
  CONNECT_REQUEST,
  CONNECT_SUCCESS
} from './../../actions/messenger/auth'

const INITIAL_STATE = {
  user: null,
  status: {
    attempted: false,
    fetching: false,
    authenticated: false,
    failed: false
  }
}

export default function auth (state = INITIAL_STATE, action) {
  switch (action.type) {
    case CONNECT_REQUEST:
      return {
        ...state,
        user: null,
        status: {
          ...state.status,
          attempted: false,
          fetching: true,
          authenticated: false,
          failed: false
        }
      }
    case CONNECT_SUCCESS:
      return {
        ...state,
        user: action.user,
        status: {
          ...state.status,
          attempted: false,
          fetching: false,
          authenticated: true,
          failed: false
        }
      }
    case CONNECT_FAILURE:
      return {
        ...state,
        user: null,
        status: {
          ...state.status,
          attempted: false,
          fetching: false,
          authenticated: false,
          failed: true
        }
      }

    default:
      return state
  }
}
